import React from 'react';

import { StyleSheet, Text } from 'react-native';
import type { TextStyle } from 'react-native';

import { Box, BoxProps } from 'components/ui/box';
import { primitive, spacing } from 'styles/constants';

export const LogoContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.logoContainer, style],
  });

export const QRContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.qrContainer, style],
  });

export const QRWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.qrWrapper, style],
  });

export const PickupPin = ({ children, style, ...props }: BoxProps) =>
  React.createElement(
    Box,
    {
      ...props,
      style: [styles.pickupPin, style],
    },
    React.createElement(Text, { style: styles.pickupPinText }, children)
  );

const styles = StyleSheet.create({
  logoContainer: {
    alignSelf: 'center',
    marginTop: spacing.$4,
    width: spacing.$32,
  },
  pickupPin: {
    padding: spacing.$2,
  },
  pickupPinText: {
    fontSize: primitive.fontSizes['3xl'],
    textAlign: 'center',
  } as TextStyle,
  qrContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: spacing.$4,
    marginTop: spacing.$8,
  },
  qrWrapper: {
    backgroundColor: primitive.$white,
    padding: spacing.$3,
  },
});
